export default __webpack_public_path__ + "static/media/header.505373df.jpg";